module.exports = __webpack_public_path__ + "img/box2.9db6cbfa.png";